import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import CancelWrapper from '../CancelWrapper/CancelWrapper';
import Helmet from 'react-helmet';
import en from '../../../international/translations/en';
import signIn from '../../../utils/signIn';
import { deleteSubscription } from '../../../common/api/subscription';
import PasswordForm from '../PasswordForm/PasswordForm';
import config from '../../../config';
import { showCancellationProgress } from '../../../redux/Cancel/subscription';

class CancelVerify extends Component {
  static propTypes = {
    params: PropTypes.object,
    session: PropTypes.object,
    children: PropTypes.object,
    user: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.props.showCancellationProgress(3);
    if (window.analytics) {
      window.analytics.page('Cancel Funnel', 'Verification');
    }
  }

  verifyPassword(values, dispatch) {
    return new Promise((resolve, reject) => {
      const password = values.password;
      const email = values.email;
      const client_id = config.client_id; // eslint-disable-line camelcase
      const { onTrial } = this.props.subscription;
      signIn({ password, email, client_id }, dispatch)
        .then(() => {
          const options = { onTrial };
          deleteSubscription(
            this.props.match.params.subscriptionId,
            this.props.session.accessToken,
            { options }
          )
            .then(() => {
              if (window.analytics) {
                window.analytics.track('Cancelled Subscription', {
                  location: 'cancel-funnel-verification',
                });
              }
              resolve(this.context.router.history.push(`/cancel/${this.props.match.params.subscriptionId}/thanks`, ), );
            })
            .catch(() =>
              reject({
                password: 'Contact customer support to cancel subscription.',
              }), );
        })
        .catch(() => reject({ password: 'Password Incorrect' }));
    });
  }

  render() {
    return (
      <CancelWrapper>
        <Helmet title={en.cancellation_funnel.meta_title_verify} />
        <h1 className="cancel-verify__title">
          {en.cancellation_funnel.title_verify_password}
        </h1>
        <PasswordForm
          onSubmit={this.handleSubmit}
          submitFunc={this.verifyPassword.bind(this)}
          userEmail={this.props.user.email}
          formLocation="cancel-funnel-verification"
        />
        {this.props.children}
      </CancelWrapper>
    );
  }
}

export default connect(state => ({
  user: state.user,
  session: state.session,
  subscription: state.subscription.currentSubscriptionForBrand,
}), { showCancellationProgress })(CancelVerify);
